import { render, staticRenderFns } from "./GeneralCoupons.vue?vue&type=template&id=30d87d52&scoped=true&"
import script from "./GeneralCoupons.vue?vue&type=script&lang=js&"
export * from "./GeneralCoupons.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCoupons.vue?vue&type=style&index=0&id=30d87d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d87d52",
  null
  
)

export default component.exports